import { message, Upload } from 'antd';
import * as React from 'react';
import withStyles from 'react-jss';
import { isOrgReliance } from 'src/api/utils';
import { useReduxState } from 'src/hooks/useRedux';
import { StylesProps } from 'src/Library/Types';
import { getFileExtension } from 'src/utils/utils';
import HorizontalSpinner from './HorizontalLoader';

interface SEFieldDocumentProps extends StylesProps<ReturnType<typeof styles>>{
  isUploading?: false;
  disabled?: boolean;
  children?: any;
  classes: any;
  sizeLimit: number;
  accept: string;
}

const SEFieldDocument: React.FC<SEFieldDocumentProps> = ({
  isUploading,
  classes,
  sizeLimit,
  disabled = false,
  accept,
  ...props
}) => {
  const isDisabled = disabled || isUploading;
  const fileUploadSizeLimit: number = useReduxState(
    ["masterData", "execution", "fileUploadSizeLimit"]
  ).value;
  const sizeLimitInBytes = fileUploadSizeLimit * 1000000;

  if (isUploading) {
    return <HorizontalSpinner />;
  }

  return (
    <Upload
    disabled={isDisabled}
    showUploadList={false}
    multiple
    accept={accept}
    beforeUpload={(file) => {
      const fileType = getFileExtension(file.name).toLowerCase();
      if (accept) {
        /** removing dot and spaces */
        const allowedTypes =
          accept.replace(/\s|\./g, '').split(',');
        if (!allowedTypes.includes(fileType)) {
          message.error('Invalid File Type');
          return false;
        }
      }
      if (file.size === 0) {
        message.error('Cannot upload zero byte file');
        return false;
      }
      if (isOrgReliance()) {
        if (file.size > sizeLimitInBytes) {
          message.error('File size exceeds ' + fileUploadSizeLimit + 'MB');
          return false;
        }
      }

      return false;
    }}
    {...props}
    >
      <span className={`${classes.blueLink} ${isDisabled ? classes.disabledLink : ''}`}>
        + Upload Document
      </span>
    </Upload>
  );
};

const styles = theme => ({
  blueLink: {
    color: theme.colors.primaryDark,
    fontSize: theme.fontSize.small,
    fontWeight: theme.fontWeight.semibold,
    cursor: 'pointer',
  },
  disabledLink: {
    color: '#999',
    cursor: 'not-allowed',
  },
});

export default React.memo(withStyles(styles)(SEFieldDocument));
